import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  useGetTablesMutation,
  useSaveDataSourceMutation,
  useGetsaveTempdataPostgresqlTablenameMutation,
  // ✅ Added this
} from "./sqlApiSlice";
import { useGetDatasourceQuery } from "./TablesourceApiSlice";
import TableSource from "./TableSource";
import ColumTable from "./ColumTable";
import { FaTableCells } from "react-icons/fa6";
import { FaDatabase } from "react-icons/fa";
import SelectBox from "../../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";

export default function ConfigdataSource() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const connectionId = searchParams.get("connectionId");

  const databases = location?.state?.response || [];
  const initialTables = location?.state?.tables || [];
  const databaseType = location?.state?.dbType;

  function modifiedArray(array) {
    return array.map((db) => ({ label: db, value: db }));
  }

  const modifiedDatabasesArray = modifiedArray(databases);
  const [selectedDatabase, setSelectedDatabase] = useState(databases[0]);
  const [selectedTable, setSelectedTable] = useState("");
  const [nickName, setNickName] = useState("");

  // ✅ QUERY HOOK for refetching
  const {
    refetch,
    isError: isErrorpg,
    error: errorpg,
  } = useGetDatasourceQuery();

  const [getTables, { data: tableData, isLoading, isSuccess, isError, error }] =
    useGetTablesMutation();

  const [
    saveDataSource,
    {
      data: saveDataSourceMessage,
      isLoading: isSaveDataSourceLoading,
      isError: isSaveDataSourceError,
      isSuccess: isSaveDataSourceSuccess,
      error: saveDataSourceError,
    },
  ] = useSaveDataSourceMutation();

  const [
    renameTable,
    {
      data: datapgrename,
      isLoading: isLoadingpgrename,
      isSuccess: isSuccesspgrename,
      isError: isErrorpgrename,
      error: errorpgrename,
    },
  ] = useGetsaveTempdataPostgresqlTablenameMutation();

  const modifiedTablesArray =
    tableData?.tables?.length
      ? modifiedArray(tableData.tables)
      : initialTables?.length
        ? modifiedArray(initialTables)
        : [];

  useEffect(() => {
    if (databaseType === "mysql" && selectedDatabase) {
      getTables({ connectionId, selectedDatabase });
    }
  }, [databaseType, selectedDatabase, connectionId, getTables]);

  useEffect(() => {
    if (selectedTable) {
      setNickName(selectedTable);
    }
  }, [selectedTable]);

  const handleDatabaseChange = (e) => setSelectedDatabase(e.target.value);
  const handleTableChange = (e) => setSelectedTable(e.target.value);

  // ✅ REFETCH AND REDIRECT after success
  useEffect(() => {
    const mysqlSuccess = saveDataSourceMessage?.success;
    const postgresSuccess = datapgrename?.success;

    if (mysqlSuccess || postgresSuccess) {
      refetch(); // ✅ refresh data source list
      const timer = setTimeout(() => {
        navigate("/datasource");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [saveDataSourceMessage, datapgrename, refetch, navigate]);

  const handleSaveDataSource = () => {
    const body = {
      connectionId,
      nickName,
      modifiedColumns: [],
    };
    if (databaseType === "mysql") {
      saveDataSource(body);
    } else if (databaseType === "postgresql") {
      renameTable(body);
    }
  };

  return (
    <main className="flex flex-col items-center justify-start h-screen overflow-hidden">
      <header className="flex flex-col items-center justify-between w-full border-b h-auto px-2 bg-gray-100 md:flex-col lg:flex-row">
        <div className="flex items-center justify-start gap-2 font-medium w-full md:w-full lg:w-[18%] h-full truncate md:py-1">
          Database Type
          <span className="flex items-center font-light border border-l-[4px] border-blue-950 px-2 w-auto gap-2">
            <FaDatabase className="text-blue-950" /> {databaseType}
          </span>
        </div>
        <div className="flex flex-col w-full md:w-full lg:w-[82%] lg:flex-row xl:w-[90%] xl:flex-row items-center md:justify-start lg:justify-between gap-2 h-auto md:py-1">
          <div className="flex flex-col lg:flex-row items-center justify-start w-full md:gap-y-2 lg:gap-x-2">
            <section className="flex w-full md:w-full lg:w-[50%] items-center justify-start gap-2">
              <span className="flex w-auto font-medium truncate text-center">
                Database Name
              </span>
              <section className="w-full md:w-[65%] lg:w-[33rem] flex">
                <SelectBox
                  value={selectedDatabase}
                  optionsArray={modifiedDatabasesArray}
                  onChange={handleDatabaseChange}
                />
              </section>
            </section>
            <section className="flex w-full md:w-full lg:w-[50%] items-center justify-start gap-2">
              <span className="w-full md:w-[15%] font-medium truncate text-center">
                Tables
              </span>
              {!selectedDatabase && (
                <span className="flex items-center font-light border border-l-[4px] border-blue-950 px-2 w-full md:w-[85%] gap-2">
                  <FaTableCells className="text-blue-950" /> To select a table
                  select a database
                </span>
              )}
              {modifiedTablesArray.length && (
                <section className="w-full md:w-[85%] flex">
                  <SelectBox
                    value={selectedTable}
                    optionsArray={modifiedTablesArray}
                    onChange={handleTableChange}
                    isArrayBig={modifiedTablesArray.length > 6}
                  />
                </section>
              )}
            </section>
          </div>
        </div>
      </header>

      <section className="flex flex-col lg:flex-row w-full items-start justify-start h-auto lg:h-[87%] px-2 gap-2 overflow-hidden overflow-y-auto">
        {selectedTable && databaseType && (
          <TableSource
            connectionId={connectionId}
            selectedTable={selectedTable}
            setNickName={setNickName}
            nickName={nickName}
          />
        )}
        {databaseType === databaseType && (
          <ColumTable
            connectionId={connectionId}
            selectedTable={selectedTable}
          />
        )}
      </section>

      <div className="flex items-center justify-end gap-2 w-full h-auto py-4 pr-2">
        {(isSaveDataSourceError || isErrorpgrename || isError || isErrorpg) && (
          <p className="text-red-500">
            {saveDataSourceError?.data?.message ||
              errorpgrename?.data?.message ||
              error?.data?.message ||
              errorpgrename?.message ||
              error?.message ||
              errorpg?.message}
          </p>
        )}

        {/* {isSaveDataSourceSuccess && (
          <p className="text-green-500">{saveDataSourceMessage?.success}</p>
        )} */}
        {(isSaveDataSourceSuccess || isSuccesspgrename || isSuccess) && (
          <p className="text-green-500">
            {saveDataSourceMessage?.success ||
              datapgrename?.success ||
              isSuccess?.success}
          </p>
        )}
        <button
          className="bg-blue-950 text-white font-bold py-1 px-2 rounded"
          onClick={handleSaveDataSource}
          disabled={isSaveDataSourceLoading}
        >
          Save Data
        </button>
      </div>
    </main>
  );
}
